var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoSmLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36.82 36.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#009fe3;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Recurso 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,18.41c0,.25,0,.49,0,.73l.07,0c4.17-1,7.89.1,10.88.95,2.78.79,4.54,1.24,5.67.44,2-1.39,3.24-6.84,3.79-16.19A29.6,29.6,0,0,0,20.4.11a18.81,18.81,0,0,0-2-.11A18.41,18.41,0,0,0,0,18.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.45,1a34.44,34.44,0,0,1,0,3.52C23.77,15.92,22.18,21.49,19,23.77c-2.74,1.95-6,1-9.08.15C7.08,23.12,4.17,22.29,1,23l-.39.1A18.4,18.4,0,1,0,24.45,1Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmLight);
export default __webpack_public_path__ + "static/media/logo-sm-light.b89b8e57d20fccbb6034248aa342dfcf.svg";
export { ForwardRef as ReactComponent };